module.exports = __webpack_public_path__ + "static/img/conveyor-lift-mk-2_256.100dd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-lift-mk-2_256.png
// module id = e6bX
// module chunks = 0